<footer>
  <p>
    Made with ❤ by <a href="https://lvq.dk">LVQ Consult ApS</a> in the EU 🇪🇺 ·
    © 2023
  </p>
</footer>
